<template>
  <div class="stepInfo">
    <div class="shadow">
      <div class="step">
        <div
          class="step_item"
          v-for="(item, index) in historyList"
          :key="index"
          :class="{'step_active':index!=historyList.length-1}"
        >
          <!-- 小圆点 -->
          <span class="col" :class="{'currenCol': index === 0}"></span>
          <div class="title" v-if="item.optType!=1||item.optText=='退货件转办'">
            <p class="title-left">
              <span class="optText">{{item.optText}}</span>
              <!-- <span class="Check">
                查看
                <van-icon class="arrow" name="arrow" />
              </span>-->
            </p>
            <span class="time">{{item.creatTime|timefilt}}</span>
            <!-- {{item.optText}}
            <span class="r_text" v-if="small&&small==5&&item.optType=='110'">：满意</span>
            <span class="r_text" v-if="small&&small==3&&item.optType=='110'">：基本满意</span>
            <span class="r_text" v-if="small&&small==1&&item.optType=='110'">：不满意</span>
            <img
              src="../../../../assets/image/happy.png"
              v-if="small&&small==5&&item.optType=='110'"
              class="small"
            />
            <img
              src="../../../../assets/image/norCopy.png"
              v-if="small&&small==3&&item.optType=='110'"
              class="small"
            />
            <img
              src="../../../../assets/image/unhappy.png"
              v-if="small&&small==1&&item.optType=='110'"
              class="small"
            />-->
          </div>
          <p class="title" v-if="item.optType==1&&item.optText!='退货件转办'">
            <span>退货单已发起</span>
            <span class="time">{{item.creatTime|timefilt}}</span>
          </p>
          <div class="step_content" v-if="item.optType!=1||item.optText=='退货件转办'">
            <!-- <p class="time">{{item.creatTime|timefilt}}</p> -->
            <p class="type" v-if="item.optType!=110&&item.optType!=150">
              <span class="title_text">{{ index === (historyList.length - 2) ? '处置机构' : '协助处置机构' }}</span>
              <span class="title_content">{{item.optMechanismName}}</span>
            </p>
            <p class="name" v-if="item.optType!=110&&item.optType!=150">
              <span class="title_text">{{ index === (historyList.length - 2) ? '处置人员' : '协助处置人员' }}</span>
              <!-- <span class="title_content">{{item.optName}}-联系电话：</span> -->
              <span class="title_content">{{item.optName}}</span>
              <!-- <span
                :class="{'phone':index==0,'title_content':index!== 0}"
                @click="showPhone(item.optContactTel)"
              >{{item.optContactTel}}</span>-->
            </p>
            <p class="info" v-if="index === (historyList.length - 2)">
              <span class="title_text">补充说明</span>
              <span class="title_content">{{item.optContent}}</span>
            </p>
            <p class="info" v-if="item.optText === '退货方式变更' && item.change">
              <span class="title_text">变更内容</span>
              <span class="title_content">退货方式由 {{ item.change }}</span>
            </p>
            <p class="info" v-if="item.optText === '退货方式变更' && item.change">
              <span class="title_text">补充说明</span>
              <span class="title_content">{{ changeStr(item.optContent) }}</span>
            </p>
            <!-- <p class="info" v-if="item.optContent!=''&&item.optType==110">
              <span class="title_text">评价内容：</span>
              <span class="title_content">{{item.optContent}}</span>
            </p>
            <div class="item_img" v-if="item.optType=='70'">
              <img
                :src="item1.fileUrl"
                v-for="(item1,index1) in item.attachment"
                :key="index1"
                @click="showImg1(index1)"
              />
            </div>-->
          </div>
          <div
            class="step_content"
            v-if="item.optType==1 && item.optText=='发起退货'"
            :class="{'step_content1':item.optText=='发起退货'}"
          >
            <!-- <p class="time">{{ item.creatTime | timefilt }}</p> -->
            <p class="type">
              <span class="title_text">退货人：</span>
              <span class="title_content">{{ detail.purchaser }}</span>
            </p>
            <!-- <p class="name">
              <span class="title_text">商家名称：</span>
              <span class="title_content">{{addRess.shoppingStore}}</span>
            </p>-->
            <p class="info" v-if="item.optContent!=''">
              <span class="title_text">退货原因：</span>
              <span class="title_content">{{ getrefundReason(detail.refundReason) }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="box1" v-if="historyList==''">
      <img src="../../../../assets/empty/ic_wuxingxi.png" />
      <p class="tip1">暂无数据</p>
    </div>
    <call-phone ref="callPhone" :combinPhone="combinPhone"></call-phone>
    <!-- <md-image-viewer v-model="isShow1" :list="images" :has-dots="true" :initial-index="viewerIndex"></md-image-viewer> -->
  </div>
</template>
<script>
    import moment from 'moment';
    import util from '../../../../utils/common';
    import callPhone from '../../../../components/callPhone';
    export default {
        components: {
            'call-phone': callPhone
        },
        props: ['historyInfo', 'detail'],
        data () {
            return {
                combinPhone: 0,
                addRess: util.getJsonLocal('detail'),
                small: '',
                common: '',
                isShow1: false,
                //     index: 0,
                //     currentIndex:0,
                viewerIndex: 0,
                images1: [],
                historyList: []
            };
        },
        created () {
            this.getInit();
            this.historyList = this._.cloneDeep(this.historyInfo)
            this.historyList.push({
                optType: 1,
                optText: '发起退货',
                creatTime: this.detail.refundTime
            });
        },
        methods: {
            getrefundReason (type) {
                const config = {
                    1: '价格虚高',
                    2: '瑕疵商品',
                    3: '发票/收据不正规',
                    4: '导游强制购物',
                    5: '不喜欢',
                    6: '其他'
                };
                return config[type];
            },
            changeStr (str) {
                return str.split('：')[1] || '无';
            },
            getInit () {
                for (var i = 0; i < this.historyInfo.length; i++) {
                    if (this.historyInfo[i].optType === 70) {
                        if (this.historyInfo[i].attachment) {
                            for (var j = 0; j < this.historyInfo[i].attachment.length; j++) {
                                this.images1.push(this.historyInfo[i].attachment[j].fileUrl);
                            }
                        }
                        break;
                    }
                }
                if (util.getJsonLocal('detail').paperworkEvaluation) {
                    this.small = JSON.parse(
                        util.getJsonLocal('detail').paperworkEvaluation
                    ).grade;
                    this.common = JSON.parse(
                        util.getJsonLocal('detail').paperworkEvaluation
                    ).comment;
                } else {
                    this.small = '';
                    this.common = '';
                }
            },
            showPhone (value) {
                this.combinPhone = parseInt(value);
                this.$refs.callPhone.showBox();
            },
            goTop () {
                window.scrollTo(0, 0);
            },
            onChange () {},
            showImg1 (index) {
                this.$router.push({
                    path: '/complaint/imagesView',
                    query: {
                        imageList: this.images1 || [],
                        index
                    }
                });
                // this.$ImagePreview({ images: this.images1, startPosition: index });
            }
        },
        filters: {
            filt (value) {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
            },
            filt1 (value) {
                return [
                    'http://returned-purchase-1254950508.cos.ap-guangzhou.myqcloud.com/dev/2019/09/21/1569071945240.png?sign=q-sign-algorithm%3Dsha1%26q-ak%3DAKIDgBGMPhB0Q9CjnH4UKvYAnkzJpn7IuBMe%26q-sign-time%3D1569072962%3B1569677762%26q-key-time%3D1569072962%3B1569677762%26q-header-list%3D%26q-url-param-list%3D%26q-signature%3D098f865180922d59eac93b8af56aaab3ba418826&x-cos-security-token=3f1652df43a7e2afdcd01d31c25d1e77b1c958b530001'
                ];
            },
            timefilt (val) {
                return util.getStampInDate2(val);
            }
        }
    };
</script>
<style scoped lang="less">
.stepInfo {
  width: 100%;
  padding: 188px 12px 60px 12px;
  box-sizing: border-box;
  background-color: #fafafa;
  .shadow {
    overflow: hidden;
    padding: 24px 16px 0 16px;
    background-color: #ffffff;
    margin-bottom: 20px;
    box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    overflow: hidden;
  }
  .step_item {
    width: 100%;
    // min-height: 60px;
    padding-top: 6px;
    //    background-color: #ffffff;
    position: relative;
    .col {
      position: absolute;
      left: -10px;
      top: -8px;
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fff;
      background-size: 100% 100%;
      // border: 1px solid @base-color;
      background-image: url("../../../../assets/refund/confirm.png");
    }
    .currenCol {
      background-image: url("../../../../assets/refund/current.png");
    }
    .title {
      font-size: 14px;
      line-height: 16px;
      color: #333333;
      position: absolute;
      left: 20px;
      top: -7px;
      display: flex;
      align-items: center;
      font-weight: 700;
      width: 95%;
      display: flex;
      justify-content: space-between;
      .title-left {
        .optText {
          margin-right: 8px;
        }
        /deep/.Check {
          font-size: 14px;
          color: #36b374;
          font-weight: 400;
          .van-icon {
            top: 1px;
            font-size: 10px;
          }
        }
      }
      .time {
        font-size: 12px;
        color: #a2a3a4;
        // line-height: 1.6em;
        font-weight: 400;
      }
      .r_text {
        display: inline-block;
        vertical-align: middle;
      }
      .small {
        margin-left: 8px;
        display: inline-block;
        vertical-align: middle;
        width: 14px;
        height: 14px;
      }
    }
    .step_content {
      margin-left: 20px;
      padding-bottom: 48px;
      p {
        font-size: 14px;
        margin-top: 12px;
      }

      .type {
        color: #9b9b9b;
        display: flex;
        align-items: center;
        margin-top: 16px;
        // line-height: 1.6em;
      }
      .info {
        display: flex;
        // align-items: center;
        margin-top: 6px;
        width: 100%;
        white-space: wrap;
        overflow: hidden;
        line-height: 1.5em;
        // padding-bottom: 20px;
      }
      .name {
        display: flex;
        align-items: center;
        // line-height: 1.5em;
      }
      .phone {
        color: #36b374;
      }
      .item_img {
        margin-top: 10px;
        img {
          width: 58px;
          height: 58px;
          display: inline-block;
          margin-right: 10px;
          border-radius: 3px;
        }
      }
      .title_text {
        font-size: 14px;
        color: #71747a;
        margin-right: 12px;
        font-weight: 400;
        min-width: 56px;
      }
      .title_content {
        font-size: 14px;
        font-weight: 400;
        color: #171a1d;
        // white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // max-width: 225px;
        display: inline-block;
      }
    }
    .step_content1 {
      padding-bottom: 16px;
    }
  }
  .step_active {
    border-left: 1px solid #36b374;
  }

  .box1 {
    text-align: center;
    margin-top: 64px;
    background-color: white;
    img {
      display: inline-block;
      width: 74px;
      height: 62px;
    }
    .tip1 {
      font-size: 14px;
      color: #9b9b9b;
      margin-top: 24px;
    }
    .tip2 {
      font-size: 14px;
      color: #9b9b9b;
      margin-top: 8px;
    }
  }
}
</style>
